import { render, staticRenderFns } from "./CategoriaProdutoForm.vue?vue&type=template&id=b47900ec"
import script from "./CategoriaProdutoForm.vue?vue&type=script&lang=js"
export * from "./CategoriaProdutoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports